export const stripHeader = (name?: string) =>
  String(name || "")
    .replace(/^\uFEFF/, "")
    .trim();

export const normalizeVariableKey = (name?: string) =>
  stripHeader(name)
    .replace(/([a-z0-9])([A-Z])/g, "$1_$2")
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1_$2")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");

export const isPhoneNumberHeader = (header?: string) =>
  normalizeVariableKey(header) === "phone_number";

export const extractTemplateVariableNames = (template?: string): string[] => {
  const names: string[] = [];
  const seen = new Set<string>();
  const add = (name: string) => {
    const key = stripHeader(name);
    if (!key || seen.has(key)) return;
    seen.add(key);
    names.push(key);
  };
  String(template || "")
    .replace(/\{\{\{\s*([^}]+?)\s*\}\}\}/g, (_, name) => {
      add(name);
      return "";
    })
    .replace(/\{\{\s*([^}]+?)\s*\}\}/g, (_, name) => {
      add(name);
      return "";
    })
    .replace(/\{([a-zA-Z_][a-zA-Z0-9_]*)\}/g, (_, name) => {
      add(name);
      return "";
    });
  return names;
};
